// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_section-header__+rHji"};